export function AuthError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p role="alert" className="text-sm text-destructive-strong">
      {message}
    </p>
  );
}

export function AuthNotice({ message }: { message?: string }) {
  if (!message) return null;
  return (
    <p role="status" className="rounded-md bg-muted px-3 py-2 text-sm">
      {message}
    </p>
  );
}
